<template>
  <div>
    <h1 id="header">Lucchese Computação e Estatística</h1>

    <b-navbar toggleable="md" type="light" variant="transparent">
      <b-navbar-brand to="/">
          <img src="../assets/lcelogo2.png" alt="Logo">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/sobre">Sobre</b-nav-item>
<!--           <b-nav-item-dropdown text="Soluções" left>
            <b-dropdown-item to="/pergamin">Pergamin Organic</b-dropdown-item>
            <b-dropdown-item to="/nfs">NFSePOA</b-dropdown-item>
            <b-dropdown-item to="/personalizadas">Soluções personalizadas</b-dropdown-item>
          </b-nav-item-dropdown> -->
          <b-nav-item to="/contato">Contato</b-nav-item>
          <!-- <b-nav-item href="http://pergamin.com.br">Pergamin.com.br</b-nav-item> -->
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#header {
  text-transform: uppercase;
  text-align: center;
  padding-top: 4vh;
  color: rgb(114, 92, 29)
}
#menudrop {
  font-family: Arial, Helvetica, sans-serif;
  text-align: left;
}
</style>